var location = {};
export default {
    saveLocation(key,element) {
        location[key] = {
            element,
            offset:element.scrollTop
        }
    },
    recoverLocation(key) {
        if(location[key] != null) {
            var {element,offset} = location[key]
            element.scrollTop = offset;
        }
    }
}


// WEBPACK FOOTER //
// ./src/common/scollerLocation.js